import { Box, Spacer, TextNew } from '@jfs/ui-new'
import { FC, ReactElement } from 'react'
import { TableComponent } from '../../comps/TableComponent'
import { refundHeaderData } from '../../data/static/data'
import { refundData } from '../../data/static/dummydata'
import { paymentDetailsStrings } from '../../data/static/strings'
import { useStores } from '../../data/store'
import { useWindowDimensions } from '../../util/util'
import { styles } from './styles'

interface DataType {
  id: string
  value: string | number
}
interface RefundProps {
  rrnValue: string
}

const getItemView = (obj: DataType, themes: any, index: number): ReactElement => {
  let style = { ...themes.listItemText }
  if (obj.id === 'rrn') {
    style = { ...themes.listItemText, width: 150 }
  }
  return (
    <Box f={1}>
      <TextNew testID={`${obj.id}${index}`} {...style}>
        {obj.value.toString()}
      </TextNew>
    </Box>
  )
}

const renderItem = ({ item, index }: { item: typeof refundData[0]; index: number }, themes: any): ReactElement => {
  const listData: any = Object.entries(item).map((element) => ({
    id: element[0],
    value: element[1],
  }))
  const listItems = listData.map((obj: any) => getItemView(obj, themes, index))
  return <Box {...themes.listItemContainer}>{listItems}</Box>
}

const getheaderView = (obj: DataType, themes: any): ReactElement => {
  let style = themes.hoverHeaderText
  if (obj.id === 'rrn') {
    style = { ...themes.hoverHeaderText, width: 150 }
  }
  return (
    <Box f={1}>
      <TextNew type="body12" fontWeight="BOLD" {...style}>
        {obj.value.toString()}
      </TextNew>
    </Box>
  )
}

const renderHeader = (themes: any): ReactElement => {
  const listData: DataType[] = Object.entries(refundHeaderData).map((element) => ({
    id: element[0],
    value: element[1],
  }))
  const headerItems = listData.map((obj) => getheaderView(obj, themes))
  return <Box {...themes.listHeaderContainer}>{headerItems}</Box>
}

const RefundDetails: FC<RefundProps> = ({}: RefundProps) => {
  const { newFetchHoverTableData } = useStores((store) => ({
    newFetchHoverTableData: store.transactions.newFetchHoverTableData,
  }))

  let tableData = newFetchHoverTableData()

  if (tableData.length === 0) {
    tableData = refundData
  }

  const viewPortWidth = useWindowDimensions()

  const themes = styles(viewPortWidth)

  const renderListItem = (item: any, index: number): ReactElement => {
    return renderItem(item, themes, index)
  }

  const renderHeaderItem = (): ReactElement => {
    return renderHeader(themes)
  }

  return (
    <Box {...themes.detailsContainer}>
      <TextNew type={'body16'} fontWeight="bold">
        {paymentDetailsStrings.labelRefundDetails}
      </TextNew>
      <Spacer size={16} />
      <TableComponent
        value={''} //Routes value
        canFetchMore={false}
        ListContent={tableData}
        hide={false}
        contentContainerStyle={themes.list}
        isCustom={true}
        RenderCustomElement={renderListItem}
        ListHeaderComponent={renderHeaderItem}
      />
    </Box>
  )
}

export default RefundDetails
